package com.havn.app.features.tasks.presentation

import androidx.compose.foundation.BorderStroke
import androidx.compose.foundation.background
import androidx.compose.foundation.clickable
import androidx.compose.foundation.layout.Arrangement
import androidx.compose.foundation.layout.Box
import androidx.compose.foundation.layout.BoxWithConstraints
import androidx.compose.foundation.layout.Column
import androidx.compose.foundation.layout.ExperimentalLayoutApi
import androidx.compose.foundation.layout.FlowRow
import androidx.compose.foundation.layout.PaddingValues
import androidx.compose.foundation.layout.Row
import androidx.compose.foundation.layout.Spacer
import androidx.compose.foundation.layout.fillMaxHeight
import androidx.compose.foundation.layout.fillMaxSize
import androidx.compose.foundation.layout.fillMaxWidth
import androidx.compose.foundation.layout.height
import androidx.compose.foundation.layout.heightIn
import androidx.compose.foundation.layout.padding
import androidx.compose.foundation.layout.size
import androidx.compose.foundation.layout.width
import androidx.compose.foundation.layout.widthIn
import androidx.compose.foundation.shape.CircleShape
import androidx.compose.foundation.lazy.LazyColumn
import androidx.compose.foundation.lazy.items
import androidx.compose.foundation.lazy.rememberLazyListState
import androidx.compose.foundation.shape.RoundedCornerShape
import androidx.compose.material3.AlertDialog
import androidx.compose.material3.Checkbox
import androidx.compose.material3.MaterialTheme
import androidx.compose.material3.Surface
import androidx.compose.material3.Text
import androidx.compose.material3.TextButton
import androidx.compose.runtime.Composable
import androidx.compose.runtime.LaunchedEffect
import androidx.compose.runtime.collectAsState
import androidx.compose.runtime.getValue
import androidx.compose.runtime.mutableStateOf
import androidx.compose.runtime.remember
import androidx.compose.runtime.setValue
import androidx.compose.ui.Alignment
import androidx.compose.ui.Modifier
import androidx.compose.ui.draw.clip
import androidx.compose.ui.graphics.Brush
import androidx.compose.ui.graphics.Color
import androidx.compose.ui.text.style.TextAlign
import androidx.compose.ui.text.style.TextOverflow
import androidx.compose.ui.unit.dp
import com.havn.app.core.designsystem.HavnButton
import com.havn.app.core.designsystem.HavnButtonStyle
import com.havn.app.core.designsystem.HavnCard
import com.havn.app.core.designsystem.EmptyState
import com.havn.app.core.designsystem.HavnIcon
import com.havn.app.core.designsystem.HavnIconKey
import com.havn.app.core.designsystem.HavnInfiniteListLoadEffect
import com.havn.app.core.designsystem.HavnListDefaults
import com.havn.app.core.designsystem.HavnListFilterChip
import com.havn.app.core.designsystem.HavnListRowSeparator
import com.havn.app.core.designsystem.HavnPullToRefreshBox
import com.havn.app.core.designsystem.HavnPushNavigation
import com.havn.app.core.designsystem.HavnScreenFrame
import com.havn.app.core.designsystem.HavnSearchField
import com.havn.app.core.designsystem.HavnSkeletonBlock
import com.havn.app.core.designsystem.HavnSkeletonListFooter
import com.havn.app.core.designsystem.HavnSpacing
import com.havn.app.core.designsystem.HavnTextField
import com.havn.app.core.designsystem.HavnTopHeaderTextStyle
import com.havn.app.core.designsystem.HavnWebRefreshAction
import com.havn.app.core.designsystem.havnIsWebShell
import com.havn.app.core.designsystem.havnNeedsNativeTabBarContentInset
import com.havn.app.core.localization.HavnStrings
import com.havn.app.core.localization.LocalHavnStrings
import com.havn.app.core.media.HavnFilePicker
import com.havn.app.core.media.HavnPickedFile
import com.havn.app.features.agency.domain.AgencyMember
import com.havn.app.features.agency.presentation.AgencyViewModel
import com.havn.app.features.attachments.domain.HavnAttachment
import com.havn.app.features.attachments.domain.HavnAttachmentRecipient
import com.havn.app.features.attachments.domain.HavnAttachmentRecipientSource
import com.havn.app.features.attachments.domain.HavnAttachmentSharePhoto
import com.havn.app.features.attachments.presentation.AttachmentSection
import com.havn.app.features.attachments.presentation.AttachmentsUiState
import com.havn.app.features.clients.domain.Client
import com.havn.app.features.clients.presentation.ClientsViewModel
import com.havn.app.features.followups.domain.FollowUp
import com.havn.app.features.followups.domain.FollowUpStatus
import com.havn.app.features.followups.presentation.FollowUpsViewModel
import com.havn.app.features.leads.domain.Lead
import com.havn.app.features.leads.presentation.LeadsViewModel
import com.havn.app.features.openhouses.domain.LeadTemperature
import com.havn.app.features.openhouses.domain.OpenHouse
import com.havn.app.features.openhouses.domain.OpenHouseStatus
import com.havn.app.features.openhouses.presentation.OpenHousesViewModel
import com.havn.app.features.properties.domain.Property
import com.havn.app.features.properties.presentation.PropertiesViewModel
import com.havn.app.features.tasks.domain.AiSuggestedTask
import com.havn.app.features.tasks.domain.HavnTask
import com.havn.app.features.tasks.domain.HavnTaskDraft
import com.havn.app.features.tasks.domain.HavnTaskPriority
import com.havn.app.features.tasks.domain.HavnTaskStatus
import com.havn.app.features.tasks.domain.HavnTaskType
import com.havn.app.features.tasks.presentation.TaskBoardColumn
import com.havn.app.features.tasks.presentation.TaskScreenMode
import com.havn.app.ui.theme.LocalHavnThemeTokens
import kotlin.time.Clock
import kotlin.time.ExperimentalTime
import kotlin.time.Instant

@Composable
fun TasksScreen(
    viewModel: TasksViewModel,
    filePicker: HavnFilePicker,
    attachmentsState: AttachmentsUiState = AttachmentsUiState(),
    propertiesViewModel: PropertiesViewModel,
    openHousesViewModel: OpenHousesViewModel,
    leadsViewModel: LeadsViewModel,
    followUpsViewModel: FollowUpsViewModel,
    clientsViewModel: ClientsViewModel,
    agencyViewModel: AgencyViewModel,
    onOpenProperty: (String) -> Unit = {},
    onOpenContact: (String) -> Unit = {},
    onOpenOpening: (String) -> Unit = {},
    onOpenLead: (String) -> Unit = {},
    onBackToToday: (() -> Unit)? = null,
    taskDetailBackLabel: String? = null,
    onTaskDetailBack: (() -> Unit)? = null,
    onLoadAttachments: (String) -> Unit = {},
    onUploadAttachment: (HavnTask, HavnPickedFile?) -> Unit = { _, _ -> },
    onOpenAttachment: (HavnAttachment) -> Unit = {},
    onOpenPhotoAttachment: (HavnAttachmentSharePhoto) -> Unit = {},
    onSendAttachmentEmail: (List<HavnAttachmentRecipient>, List<HavnAttachment>, List<HavnAttachmentSharePhoto>) -> Unit = { _, _, _ -> },
    onSendAttachmentSms: (List<HavnAttachmentRecipient>, List<HavnAttachment>, List<HavnAttachmentSharePhoto>) -> Unit = { _, _, _ -> },
    onDeleteAttachment: (HavnAttachment) -> Unit = {},
    onDismissAttachmentError: () -> Unit = {},
    onUpgradePlan: () -> Unit = {},
    canUseFiles: Boolean = true,
    canUseAgencyTaskAgenda: Boolean = false,
    scrollToTopSignal: Int = 0
) {
    val state by viewModel.uiState.collectAsState()
    val propertiesState by propertiesViewModel.uiState.collectAsState()
    val openHousesState by openHousesViewModel.uiState.collectAsState()
    val leadsState by leadsViewModel.uiState.collectAsState()
    val followUpsState by followUpsViewModel.uiState.collectAsState()
    val clientsState by clientsViewModel.uiState.collectAsState()
    val agencyState by agencyViewModel.uiState.collectAsState()
    val theme = LocalHavnThemeTokens.current

    val context = remember(
        propertiesState.properties,
        openHousesState.openHouses,
        leadsState.leads,
        followUpsState.followUps,
        clientsState.clients,
        agencyState.members
    ) {
        TaskContextIndex(
            properties = propertiesState.properties.associateBy { it.id },
            openHouses = openHousesState.openHouses.associateBy { it.id },
            leads = leadsState.leads.associateBy { it.id },
            followUps = followUpsState.followUps.associateBy { it.id },
            contacts = clientsState.clients.associateBy { it.id },
            members = agencyState.members.associateBy { it.agentId }
        )
    }
    val kanbanTasks = remember(state.tasks) {
        state.tasks.filterNot { it.status == HavnTaskStatus.Cancelled }
    }
    val searchedTasks = remember(kanbanTasks, state.searchQuery) {
        kanbanTasks.searchTasks(state.searchQuery, context)
    }
    HavnPushNavigation(
        targetState = state.mode,
        depthFor = TaskScreenMode::navigationDepth
    ) { mode ->
        when (mode) {
            TaskScreenMode.Board -> TasksBoardScreen(
                state = state,
                searchedTasks = searchedTasks,
                context = context,
                isRefreshing = propertiesState.isLoading || openHousesState.isLoading || leadsState.isLoading || followUpsState.isLoading,
                onBackToToday = onBackToToday,
                onRefresh = {
                    viewModel.refresh()
                    propertiesViewModel.refresh()
                    openHousesViewModel.refresh()
                    leadsViewModel.refresh()
                    followUpsViewModel.refresh()
                    agencyViewModel.refresh()
                },
                onSearchChanged = viewModel::updateSearchQuery,
                onColumnSelected = viewModel::selectColumn,
                onLoadMore = viewModel::loadMoreTasks,
                onStartAdd = { viewModel.startAddTask() },
                onOpenTask = viewModel::openTask,
                onMoveStatus = viewModel::moveToStatus,
                scrollToTopSignal = scrollToTopSignal
            )
            TaskScreenMode.Editor -> TaskEditorScreen(
                state = state,
                context = context,
                members = agencyState.members,
                filePicker = filePicker,
                attachmentsState = attachmentsState,
                backLabel = taskDetailBackLabel,
                onBack = onTaskDetailBack ?: viewModel::closeEditor,
                onRefresh = viewModel::refresh,
                onSave = viewModel::saveTask,
                onFormChange = viewModel::updateForm,
                onOpenProperty = onOpenProperty,
                onOpenContact = onOpenContact,
                onOpenOpening = onOpenOpening,
                onOpenLead = onOpenLead,
                onLoadAttachments = onLoadAttachments,
                onUploadAttachment = onUploadAttachment,
                onOpenAttachment = onOpenAttachment,
                onOpenPhotoAttachment = onOpenPhotoAttachment,
                onSendAttachmentEmail = onSendAttachmentEmail,
                onSendAttachmentSms = onSendAttachmentSms,
                onDeleteAttachment = onDeleteAttachment,
                onDismissAttachmentError = onDismissAttachmentError,
                onUpgradePlan = onUpgradePlan,
                canUseFiles = canUseFiles,
                canUseAgencyTaskAgenda = canUseAgencyTaskAgenda
            )
        }
    }
}

@Composable
private fun TasksBoardScreen(
    state: TasksUiState,
    searchedTasks: List<HavnTask>,
    context: TaskContextIndex,
    isRefreshing: Boolean,
    onBackToToday: (() -> Unit)?,
    onRefresh: () -> Unit,
    onSearchChanged: (String) -> Unit,
    onColumnSelected: (TaskBoardColumn) -> Unit,
    onLoadMore: (TaskBoardColumn) -> Unit,
    onStartAdd: () -> Unit,
    onOpenTask: (String) -> Unit,
    onMoveStatus: (String, HavnTaskStatus) -> Unit,
    scrollToTopSignal: Int
) {
    val theme = LocalHavnThemeTokens.current
    val strings = LocalHavnStrings.current
    val bottomContentPadding = if (havnNeedsNativeTabBarContentInset) 132.dp else 18.dp
    val listState = rememberLazyListState()
    val selectedListTasks = searchedTasks.forBoardColumn(state.selectedColumn)
    var handledScrollToTopSignal by remember { mutableStateOf(scrollToTopSignal) }
    LaunchedEffect(scrollToTopSignal) {
        if (scrollToTopSignal > handledScrollToTopSignal) {
            if (listState.firstVisibleItemIndex == 0 && listState.firstVisibleItemScrollOffset == 0) {
                onRefresh()
            } else {
                listState.animateScrollToItem(0)
            }
        }
        handledScrollToTopSignal = scrollToTopSignal
    }
    HavnPullToRefreshBox(
        isRefreshing = state.isLoading || isRefreshing,
        onRefresh = onRefresh,
        modifier = Modifier
            .fillMaxSize()
            .background(Brush.verticalGradient(listOf(theme.gradientStart, theme.background, theme.gradientEnd)))
    ) {
        BoxWithConstraints(Modifier.fillMaxSize()) {
            val wide = havnIsWebShell || maxWidth >= 700.dp
            HavnInfiniteListLoadEffect(
                listState = listState,
                enabled = !wide && state.hasMoreTasks(state.selectedColumn),
                isLoading = state.isLoading || state.isLoadingMore(state.selectedColumn),
                itemCount = selectedListTasks.size,
                onLoadMore = { onLoadMore(state.selectedColumn) }
            )
            if (wide) {
                Column(
                    modifier = Modifier
                        .fillMaxSize()
                        .padding(start = 18.dp, top = 18.dp, end = 18.dp, bottom = 18.dp),
                    verticalArrangement = Arrangement.spacedBy(HavnListDefaults.headerToSearchGap)
                ) {
                    Row(modifier = Modifier.fillMaxWidth(), verticalAlignment = Alignment.CenterVertically) {
                        Text(
                            text = strings.tasksTitle,
                            modifier = Modifier.weight(1f),
                            color = theme.primaryText,
                            style = HavnTopHeaderTextStyle
                        )
                        TaskIconCircleButton(
                            icon = HavnIconKey.Plus,
                            contentDescription = strings.addTask,
                            onClick = onStartAdd
                        )
                    }

                    state.errorMessage?.let { error ->
                        Text(error, color = theme.danger, style = MaterialTheme.typography.bodyMedium)
                    }

                    HavnSearchField(
                        value = state.searchQuery,
                        onValueChange = onSearchChanged,
                        placeholder = strings.searchTasks
                    )

                    TaskColumnLabelRow(state)

                    Row(
                        horizontalArrangement = Arrangement.spacedBy(12.dp),
                        verticalAlignment = Alignment.Top,
                        modifier = Modifier
                            .fillMaxWidth()
                            .weight(1f)
                    ) {
                        TaskBoardColumn.entries.forEach { column ->
                            TaskBoardList(
                                column = column,
                                tasks = searchedTasks.forBoardColumn(column),
                                context = context,
                                onSelect = onOpenTask,
                                onMoveStatus = onMoveStatus,
                                isLoading = state.isColumnLoading(column),
                                isLoadingMore = state.isLoadingMore(column),
                                hasMore = state.hasMoreTasks(column),
                                onLoadMore = { onLoadMore(column) },
                                independentScroll = true,
                                showHeader = false,
                                modifier = Modifier
                                    .weight(1f)
                                    .fillMaxHeight()
                            )
                        }
                    }
                }
            } else {
                LazyColumn(
                    state = listState,
                    modifier = Modifier.fillMaxSize(),
                    contentPadding = PaddingValues(start = 18.dp, top = 18.dp, end = 18.dp, bottom = bottomContentPadding),
                    verticalArrangement = Arrangement.spacedBy(HavnListDefaults.headerToSearchGap)
                ) {
                    item("tasks-header") {
                        Row(modifier = Modifier.fillMaxWidth(), verticalAlignment = Alignment.CenterVertically) {
                            if (onBackToToday != null) {
                                HavnIcon(
                                    HavnIconKey.Back,
                                    contentDescription = strings.navToday,
                                    tint = theme.primaryAccent,
                                    modifier = Modifier
                                        .size(34.dp)
                                        .clickable(onClick = onBackToToday)
                                        .padding(end = 8.dp)
                                )
                            }
                            Text(
                                text = strings.tasksTitle,
                                modifier = Modifier.weight(1f),
                                color = theme.primaryText,
                                style = HavnTopHeaderTextStyle
                            )
                            TaskIconCircleButton(
                                icon = HavnIconKey.Plus,
                                contentDescription = strings.addTask,
                                onClick = onStartAdd
                            )
                        }
                    }

                    state.errorMessage?.let { error ->
                        item("tasks-error") {
                            Text(error, color = theme.danger, style = MaterialTheme.typography.bodyMedium)
                        }
                    }

                    item("tasks-search") {
                        HavnSearchField(
                            value = state.searchQuery,
                            onValueChange = onSearchChanged,
                            placeholder = strings.searchTasks
                        )
                    }

                    item("tasks-segments") {
                        TaskColumnSegments(
                            selected = state.selectedColumn,
                            state = state,
                            onSelected = onColumnSelected
                        )
                    }

                    if (state.isLoading && state.tasks.isEmpty()) {
                        items(6, key = { "task-skeleton-$it" }) {
                            TaskCardSkeleton()
                        }
                    } else if (selectedListTasks.isEmpty()) {
                        item("tasks-empty") {
                            EmptyState(
                                title = state.selectedColumn.emptyTitle(strings),
                                body = "${strings.taskEmptyBodyPrefix} ${state.selectedColumn.localizedLabel(strings)}${strings.taskEmptyBodySuffix}"
                            )
                        }
                    } else {
                        items(selectedListTasks, key = { it.id }) { task ->
                            TaskListCard(
                                task = task,
                                context = context,
                                onClick = { onOpenTask(task.id) },
                                onMoveStatus = { status -> onMoveStatus(task.id, status) }
                            )
                            HavnListRowSeparator()
                        }
                    }
                    if (state.hasMoreTasks(state.selectedColumn)) {
                        item("tasks-loading-more-mobile") {
                            HavnSkeletonListFooter()
                        }
                    }
                }
            }
        }
    }
}

@Composable
private fun TaskWorkflowSummary(state: TasksUiState, suggestionCount: Int, wide: Boolean) {
    val strings = LocalHavnStrings.current
    val todo = state.totalCount(TaskBoardColumn.ToDo)
    val inProgress = state.totalCount(TaskBoardColumn.InProgress)
    val done = state.totalCount(TaskBoardColumn.Done)
    val high = state.tasks.count { it.priority == HavnTaskPriority.High || it.priority == HavnTaskPriority.Urgent }
    if (wide) {
        Row(horizontalArrangement = Arrangement.spacedBy(12.dp), modifier = Modifier.fillMaxWidth()) {
            TaskKpiCard(strings.taskColumnToDo, todo.toString(), HavnIconKey.TodayGrid, Modifier.weight(1f))
            TaskKpiCard(strings.taskColumnInProgress, inProgress.toString(), HavnIconKey.CalendarClock, Modifier.weight(1f))
            TaskKpiCard(strings.taskColumnDone, done.toString(), HavnIconKey.Check, Modifier.weight(1f))
            TaskKpiCard(strings.taskPriorityHigh, high.toString(), HavnIconKey.Star, Modifier.weight(1f))
            TaskKpiCard(strings.aiSuggestedTasks, suggestionCount.toString(), HavnIconKey.Reports, Modifier.weight(1f))
        }
    } else {
        Column(verticalArrangement = Arrangement.spacedBy(10.dp)) {
            Row(horizontalArrangement = Arrangement.spacedBy(10.dp), modifier = Modifier.fillMaxWidth()) {
                TaskKpiCard(strings.taskColumnToDo, todo.toString(), HavnIconKey.TodayGrid, Modifier.weight(1f))
                TaskKpiCard(strings.taskColumnInProgress, inProgress.toString(), HavnIconKey.CalendarClock, Modifier.weight(1f))
            }
            Row(horizontalArrangement = Arrangement.spacedBy(10.dp), modifier = Modifier.fillMaxWidth()) {
                TaskKpiCard(strings.taskColumnDone, done.toString(), HavnIconKey.Check, Modifier.weight(1f))
                TaskKpiCard(strings.aiSuggestedTasks, suggestionCount.toString(), HavnIconKey.Reports, Modifier.weight(1f))
            }
        }
    }
}

@Composable
private fun TaskKpiCard(title: String, value: String, icon: HavnIconKey, modifier: Modifier) {
    val theme = LocalHavnThemeTokens.current
    HavnCard(modifier = modifier, border = BorderStroke(1.dp, theme.border)) {
        Column(verticalArrangement = Arrangement.spacedBy(8.dp)) {
            Row(horizontalArrangement = Arrangement.spacedBy(8.dp), verticalAlignment = Alignment.CenterVertically) {
                HavnIcon(icon, contentDescription = title, tint = theme.primaryAccent, modifier = Modifier.size(19.dp))
                Text(title, color = theme.secondaryText, style = MaterialTheme.typography.labelLarge, maxLines = 1, overflow = TextOverflow.Ellipsis)
            }
            Text(value, color = theme.primaryText, style = MaterialTheme.typography.headlineMedium)
        }
    }
}

@Composable
private fun TaskIconCircleButton(
    icon: HavnIconKey,
    contentDescription: String,
    onClick: () -> Unit
) {
    val theme = LocalHavnThemeTokens.current
    Surface(
        modifier = Modifier
            .size(42.dp)
            .clickable(onClick = onClick),
        shape = MaterialTheme.shapes.large,
        color = theme.surface,
        border = BorderStroke(1.dp, theme.border)
    ) {
        Box(contentAlignment = Alignment.Center) {
            HavnIcon(
                icon,
                contentDescription = contentDescription,
                tint = theme.primaryAccent,
                modifier = Modifier.size(20.dp)
            )
        }
    }
}

@Composable
private fun TaskColumnSegments(
    selected: TaskBoardColumn,
    state: TasksUiState,
    onSelected: (TaskBoardColumn) -> Unit
) {
    val strings = LocalHavnStrings.current
    Row(horizontalArrangement = Arrangement.spacedBy(8.dp), modifier = Modifier.fillMaxWidth()) {
        TaskBoardColumn.entries.forEach { column ->
            Box(Modifier.weight(1f)) {
                FilterChip(
                    label = column.localizedLabel(strings),
                    count = state.totalCount(column),
                    selected = selected == column,
                    onClick = { onSelected(column) }
                )
            }
        }
    }
}

@Composable
private fun TaskColumnLabelRow(state: TasksUiState) {
    val strings = LocalHavnStrings.current
    Row(horizontalArrangement = Arrangement.spacedBy(12.dp), modifier = Modifier.fillMaxWidth()) {
        TaskBoardColumn.entries.forEach { column ->
            Row(
                modifier = Modifier.weight(1f),
                horizontalArrangement = Arrangement.spacedBy(8.dp),
                verticalAlignment = Alignment.CenterVertically
            ) {
                Surface(Modifier.size(9.dp), color = column.accent(), shape = CircleShape) {}
                Text(column.localizedLabel(strings), color = LocalHavnThemeTokens.current.primaryText, style = MaterialTheme.typography.titleMedium, modifier = Modifier.weight(1f))
                Badge(state.totalCount(column).toString(), column.accent())
            }
        }
    }
}

@Composable
private fun TaskBoardList(
    column: TaskBoardColumn,
    tasks: List<HavnTask>,
    context: TaskContextIndex,
    onSelect: (String) -> Unit,
    onMoveStatus: (String, HavnTaskStatus) -> Unit,
    isLoading: Boolean = false,
    isLoadingMore: Boolean = false,
    hasMore: Boolean = false,
    onLoadMore: () -> Unit = {},
    independentScroll: Boolean = false,
    showHeader: Boolean = true,
    modifier: Modifier
) {
    val theme = LocalHavnThemeTokens.current
    val strings = LocalHavnStrings.current
    val listState = rememberLazyListState()
    HavnInfiniteListLoadEffect(
        listState = listState,
        enabled = independentScroll && hasMore,
        isLoading = isLoading || isLoadingMore,
        itemCount = tasks.size,
        onLoadMore = onLoadMore
    )
    Surface(
        modifier = modifier
            .fillMaxWidth()
            .then(if (independentScroll) Modifier.fillMaxHeight() else Modifier.heightIn(min = 460.dp)),
        shape = MaterialTheme.shapes.large,
        color = theme.card,
        contentColor = theme.primaryText,
        border = BorderStroke(1.dp, theme.border),
        tonalElevation = 2.dp
    ) {
        Column(
            modifier = Modifier
                .fillMaxSize()
                .padding(HavnSpacing.md),
            verticalArrangement = Arrangement.spacedBy(10.dp)
        ) {
            if (showHeader) {
                Row(horizontalArrangement = Arrangement.spacedBy(8.dp), verticalAlignment = Alignment.CenterVertically) {
                    Surface(Modifier.size(9.dp), color = column.accent(), shape = CircleShape) {}
                    Text(column.localizedLabel(strings), color = theme.primaryText, style = MaterialTheme.typography.titleMedium, modifier = Modifier.weight(1f))
                    Badge(tasks.size.toString(), column.accent())
                }
            }
            if (tasks.isEmpty()) {
                if (isLoading) {
                    repeat(3) {
                        TaskCardSkeleton()
                    }
                } else {
                    Text(column.emptyTitle(strings), color = theme.secondaryText, style = MaterialTheme.typography.bodyMedium)
                }
            } else if (independentScroll) {
                LazyColumn(
                    state = listState,
                    modifier = Modifier
                        .fillMaxWidth()
                        .weight(1f),
                    verticalArrangement = Arrangement.spacedBy(10.dp),
                    contentPadding = PaddingValues(bottom = 4.dp)
                ) {
                    items(tasks, key = { it.id }) { task ->
                        TaskListCard(
                            task = task,
                            context = context,
                            onClick = { onSelect(task.id) },
                            onMoveStatus = { status -> onMoveStatus(task.id, status) }
                        )
                    }
                    if (hasMore) {
                        item("tasks-loading-more-${column.name}") {
                            HavnSkeletonListFooter()
                        }
                    }
                }
            } else {
                tasks.forEach { task ->
                    TaskListCard(
                        task = task,
                        context = context,
                        onClick = { onSelect(task.id) },
                        onMoveStatus = { status -> onMoveStatus(task.id, status) }
                    )
                }
                if (hasMore) {
                    HavnSkeletonListFooter()
                }
            }
        }
    }
}

@OptIn(ExperimentalLayoutApi::class)
@Composable
private fun TaskListCard(
    task: HavnTask,
    context: TaskContextIndex,
    onClick: () -> Unit,
    onMoveStatus: (HavnTaskStatus) -> Unit
) {
    val theme = LocalHavnThemeTokens.current
    val strings = LocalHavnStrings.current
    Surface(
        color = theme.surface,
        shape = MaterialTheme.shapes.medium,
        border = BorderStroke(1.dp, theme.border),
        modifier = Modifier.fillMaxWidth().clickable(onClick = onClick)
    ) {
        Column(modifier = Modifier.padding(12.dp), verticalArrangement = Arrangement.spacedBy(9.dp)) {
            Row(horizontalArrangement = Arrangement.spacedBy(8.dp), verticalAlignment = Alignment.Top) {
                Column(modifier = Modifier.weight(1f), verticalArrangement = Arrangement.spacedBy(6.dp)) {
                    Text(task.title, color = theme.primaryText, style = MaterialTheme.typography.titleSmall, maxLines = 2, overflow = TextOverflow.Ellipsis)
                    Text(task.description ?: task.type.label, color = theme.secondaryText, style = MaterialTheme.typography.bodyMedium, maxLines = 2, overflow = TextOverflow.Ellipsis)
                }
                TaskPriorityBadge(task.priority)
            }
            FlowRow(
                modifier = Modifier.fillMaxWidth(),
                horizontalArrangement = Arrangement.spacedBy(7.dp),
                verticalArrangement = Arrangement.spacedBy(7.dp)
            ) {
                context.propertyLabel(task)?.let { Badge(it, theme.primaryAccent) }
                context.contactLabel(task)?.let { Badge(it, theme.secondaryText) }
                context.leadLabel(task)?.let { Badge(it, theme.secondaryText) }
                context.memberLabel(task.assignedToUserId)?.let { Badge(it, theme.mutedText) }
                if (task.aiGenerated) AiBadge()
            }
            Row(
                horizontalArrangement = Arrangement.spacedBy(8.dp),
                verticalAlignment = Alignment.CenterVertically,
                modifier = Modifier.fillMaxWidth()
            ) {
                HavnIcon(
                    HavnIconKey.Calendar,
                    contentDescription = null,
                    tint = theme.primaryAccent,
                    modifier = Modifier.size(16.dp)
                )
                Text(
                    task.dueAt?.readableDateTime() ?: strings.noDueDate,
                    color = theme.secondaryText,
                    style = MaterialTheme.typography.labelMedium,
                    modifier = Modifier.weight(1f),
                    maxLines = 1,
                    overflow = TextOverflow.Ellipsis
                )
            }
            Row(
                modifier = Modifier.fillMaxWidth(),
                horizontalArrangement = Arrangement.spacedBy(8.dp),
                verticalAlignment = Alignment.CenterVertically
            ) {
                task.nextKanbanStatus()?.let { next ->
                    HavnButton(
                        next.taskActionLabel(strings),
                        onClick = { onMoveStatus(next) },
                        leadingIcon = if (next == HavnTaskStatus.Done) HavnIconKey.Check else null,
                        modifier = Modifier.weight(1f)
                    )
                }
                if (task.status == HavnTaskStatus.Done) {
                    HavnButton(
                        strings.reopen,
                        onClick = { onMoveStatus(HavnTaskStatus.Open) },
                        style = HavnButtonStyle.Secondary,
                        modifier = Modifier.weight(1f)
                    )
                }
            }
        }
    }
}

@Composable
private fun TaskCardSkeleton() {
    val theme = LocalHavnThemeTokens.current
    Surface(
        color = theme.surface.copy(alpha = 0.65f),
        shape = MaterialTheme.shapes.medium,
        border = BorderStroke(1.dp, theme.border),
        modifier = Modifier.fillMaxWidth()
    ) {
        Column(
            modifier = Modifier.padding(14.dp),
            verticalArrangement = Arrangement.spacedBy(10.dp)
        ) {
            Row(horizontalArrangement = Arrangement.spacedBy(10.dp), verticalAlignment = Alignment.CenterVertically) {
                HavnSkeletonBlock(Modifier.size(34.dp), shape = CircleShape)
                Column(modifier = Modifier.weight(1f), verticalArrangement = Arrangement.spacedBy(7.dp)) {
                    HavnSkeletonBlock(Modifier.fillMaxWidth(0.70f).height(15.dp))
                    HavnSkeletonBlock(Modifier.fillMaxWidth(0.46f).height(11.dp))
                }
                HavnSkeletonBlock(Modifier.width(72.dp).height(24.dp), shape = RoundedCornerShape(12.dp))
            }
            HavnSkeletonBlock(Modifier.fillMaxWidth(0.84f).height(10.dp))
            HavnSkeletonBlock(Modifier.fillMaxWidth(0.58f).height(10.dp))
        }
    }
}

@Composable
private fun TaskEditorScreen(
    state: TasksUiState,
    context: TaskContextIndex,
    members: List<AgencyMember>,
    filePicker: HavnFilePicker,
    attachmentsState: AttachmentsUiState,
    onBack: () -> Unit,
    onSave: () -> Unit,
    onFormChange: (TaskFormState.() -> TaskFormState) -> Unit,
    onOpenProperty: (String) -> Unit,
    onOpenContact: (String) -> Unit,
    onOpenOpening: (String) -> Unit,
    onOpenLead: (String) -> Unit,
    onLoadAttachments: (String) -> Unit,
    onRefresh: () -> Unit,
    backLabel: String?,
    onUploadAttachment: (HavnTask, HavnPickedFile?) -> Unit,
    onOpenAttachment: (HavnAttachment) -> Unit,
    onOpenPhotoAttachment: (HavnAttachmentSharePhoto) -> Unit,
    onSendAttachmentEmail: (List<HavnAttachmentRecipient>, List<HavnAttachment>, List<HavnAttachmentSharePhoto>) -> Unit,
    onSendAttachmentSms: (List<HavnAttachmentRecipient>, List<HavnAttachment>, List<HavnAttachmentSharePhoto>) -> Unit,
    onDeleteAttachment: (HavnAttachment) -> Unit,
    onDismissAttachmentError: () -> Unit,
    onUpgradePlan: () -> Unit,
    canUseFiles: Boolean,
    canUseAgencyTaskAgenda: Boolean
) {
    val theme = LocalHavnThemeTokens.current
    val strings = LocalHavnStrings.current
    val selectedTask = state.tasks.firstOrNull { it.id == state.selectedTaskId }
    val isEdit = selectedTask != null
    var showingDueAtPicker by remember(state.selectedTaskId) { mutableStateOf(false) }
    LaunchedEffect(selectedTask?.id) {
        selectedTask?.id?.let(onLoadAttachments)
    }
    HavnScreenFrame(
        eyebrow = "",
        title = if (isEdit) strings.taskDetail else strings.newTask,
        subtitle = "",
        backLabel = backLabel ?: strings.tasksTitle,
        onBack = onBack,
        isRefreshing = state.isSaving,
        headerTrailing = if (isEdit) {
            {
                HavnWebRefreshAction(
                    onRefresh = onRefresh,
                    isRefreshing = state.isLoading
                )
            }
        } else null
    ) {
        Column(verticalArrangement = Arrangement.spacedBy(14.dp), modifier = Modifier.fillMaxWidth()) {
            HavnCard(border = BorderStroke(1.dp, theme.border)) {
                Column(verticalArrangement = Arrangement.spacedBy(13.dp)) {
                    Text(strings.taskDetails, color = theme.primaryText, style = MaterialTheme.typography.titleMedium)
                    HavnTextField(
                        value = state.form.title,
                        onValueChange = { value -> onFormChange { copy(title = value) } },
                        label = strings.taskName
                    )
                    HavnTextField(
                        value = state.form.description,
                        onValueChange = { value -> onFormChange { copy(description = value) } },
                        label = strings.taskDescription,
                        singleLine = false
                    )
                    TaskDateTimeField(
                        label = strings.taskDueDateTime,
                        value = state.form.dueAt,
                        placeholder = strings.noDueDate,
                        onClick = { showingDueAtPicker = true }
                    )
                    if (state.form.dueAt != null) {
                        HavnButton(
                            text = strings.clearTaskDateTime,
                            onClick = { onFormChange { copy(dueAt = null) } },
                            style = HavnButtonStyle.Ghost,
                            leadingIcon = HavnIconKey.Trash,
                            modifier = Modifier.fillMaxWidth()
                        )
                    }
                }
            }

            if (canUseAgencyTaskAgenda) {
                TaskAgentAssignmentPicker(
                    members = members,
                    selectedAgentId = state.form.assignedToUserId,
                    strings = strings,
                    onAgentSelected = { agentId -> onFormChange { copy(assignedToUserId = agentId) } }
                )
            }

            HavnCard(border = BorderStroke(1.dp, theme.border)) {
                Column(verticalArrangement = Arrangement.spacedBy(12.dp)) {
                    Text(strings.taskPriority, color = theme.primaryText, style = MaterialTheme.typography.titleMedium)
                    Row(horizontalArrangement = Arrangement.spacedBy(8.dp), modifier = Modifier.fillMaxWidth()) {
                        HavnTaskPriority.entries.forEach { priority ->
                            Box(Modifier.weight(1f)) {
                                TaskPriorityRibbon(
                                    priority = priority,
                                    selected = state.form.priority == priority,
                                    onClick = { onFormChange { copy(priority = priority) } },
                                    modifier = Modifier.fillMaxWidth()
                                )
                            }
                        }
                    }
                    Text(strings.taskStatus, color = theme.primaryText, style = MaterialTheme.typography.titleMedium)
                    TaskStatusSegmentedControl(
                        selectedColumn = state.form.status.toBoardColumn(),
                        onColumnSelected = { column -> onFormChange { copy(status = column.status) } }
                    )
                }
            }

            TaskContextCard(
                property = context.properties[state.form.propertyId],
                contact = context.contacts[state.form.contactId],
                openHouse = context.openHouses[state.form.openHouseId],
                lead = context.leads[state.form.leadId],
                onOpenProperty = onOpenProperty,
                onOpenContact = onOpenContact,
                onOpenOpening = onOpenOpening,
                onOpenLead = onOpenLead
            )

            selectedTask?.let { task ->
                AttachmentSection(
                    attachments = attachmentsState.attachments.filter { it.taskId == task.id },
                    shareRecipients = context.allAttachmentRecipients(),
                    linkedShareRecipients = context.linkedAttachmentRecipients(task),
                    recentShareRecipients = attachmentsState.recentRecipients,
                    storageUsage = attachmentsState.storageUsage,
                    currentAgentId = attachmentsState.currentAgentId,
                    isUploading = attachmentsState.isUploading,
                    errorMessage = attachmentsState.errorMessage,
                    canUseFiles = canUseFiles,
                    onDismissError = onDismissAttachmentError,
                    onUpgradePlan = onUpgradePlan,
                    onAttach = { filePicker.pick { file -> onUploadAttachment(task, file) } },
                    onOpenAttachment = onOpenAttachment,
                    onOpenPhoto = onOpenPhotoAttachment,
                    onSendEmail = onSendAttachmentEmail,
                    onSendSms = onSendAttachmentSms,
                    onDelete = onDeleteAttachment
                )

                if (canUseAgencyTaskAgenda) {
                    HavnCard(border = BorderStroke(1.dp, theme.border)) {
                        Column(verticalArrangement = Arrangement.spacedBy(10.dp)) {
                            Text(strings.taskVisibility, color = theme.primaryText, style = MaterialTheme.typography.titleMedium)
                            ContextLine(HavnIconKey.User, strings.taskOwner, context.memberLabel(task.createdByUserId) ?: strings.taskOwnerFallback)
                            ContextLine(HavnIconKey.Leads, strings.assignedTo, context.memberLabel(state.form.assignedToUserId) ?: strings.selectedAgent)
                            Text(strings.taskVisibilityBody, color = theme.secondaryText, style = MaterialTheme.typography.bodyMedium)
                        }
                    }
                }
            }

            Row(horizontalArrangement = Arrangement.spacedBy(10.dp), modifier = Modifier.fillMaxWidth()) {
                HavnButton(strings.commonCancel, onClick = onBack, style = HavnButtonStyle.Secondary, modifier = Modifier.weight(1f))
                HavnButton(
                    if (isEdit) strings.saveTask else strings.createTask,
                    onClick = onSave,
                    leadingIcon = HavnIconKey.Check,
                    loading = state.isSaving,
                    modifier = Modifier.weight(1f)
                )
            }
        }
    }

    if (showingDueAtPicker) {
        TaskDateTimePickerDialog(
            title = strings.chooseTaskDateTime,
            initialValue = state.form.dueAt.orEmpty(),
            onDismiss = { showingDueAtPicker = false },
            onConfirm = { value ->
                onFormChange { copy(dueAt = value) }
                showingDueAtPicker = false
            }
        )
    }
}

@Composable
private fun TaskDateTimeField(
    label: String,
    value: String?,
    placeholder: String,
    onClick: () -> Unit
) {
    val theme = LocalHavnThemeTokens.current
    Column(verticalArrangement = Arrangement.spacedBy(6.dp)) {
        Text(label, color = theme.secondaryText, style = MaterialTheme.typography.labelLarge)
        Surface(
            modifier = Modifier.fillMaxWidth(),
            onClick = onClick,
            shape = MaterialTheme.shapes.medium,
            color = theme.background.copy(alpha = 0.34f),
            contentColor = theme.primaryText,
            border = BorderStroke(1.dp, theme.primaryAccent.copy(alpha = 0.44f))
        ) {
            Row(
                modifier = Modifier
                    .fillMaxWidth()
                    .heightIn(min = 54.dp)
                    .padding(horizontal = 14.dp, vertical = 10.dp),
                verticalAlignment = Alignment.CenterVertically,
                horizontalArrangement = Arrangement.spacedBy(10.dp)
            ) {
                HavnIcon(HavnIconKey.CalendarClock, contentDescription = null, tint = theme.primaryAccent, modifier = Modifier.size(18.dp))
                Text(
                    text = value?.readableDateTime() ?: placeholder,
                    color = if (value == null) theme.mutedText else theme.primaryText,
                    style = MaterialTheme.typography.bodyLarge,
                    maxLines = 1,
                    overflow = TextOverflow.Ellipsis,
                    modifier = Modifier.weight(1f)
                )
            }
        }
    }
}

@Composable
private fun TaskDateTimePickerDialog(
    title: String,
    initialValue: String,
    onDismiss: () -> Unit,
    onConfirm: (String) -> Unit
) {
    val theme = LocalHavnThemeTokens.current
    val strings = LocalHavnStrings.current
    val initial = remember(initialValue) { TaskDateTimeSelection.fromIso(initialValue) }
    var year by remember(initialValue) { mutableStateOf(initial.year) }
    var month by remember(initialValue) { mutableStateOf(initial.month) }
    var day by remember(initialValue) { mutableStateOf(initial.day.coerceAtMost(taskDaysInMonth(initial.year, initial.month))) }
    var hour by remember(initialValue) { mutableStateOf(initial.hour) }
    var minute by remember(initialValue) { mutableStateOf(initial.minute) }

    AlertDialog(
        onDismissRequest = onDismiss,
        title = { Text(title) },
        text = {
            Column(verticalArrangement = Arrangement.spacedBy(14.dp)) {
                Row(
                    modifier = Modifier.fillMaxWidth(),
                    horizontalArrangement = Arrangement.spacedBy(10.dp),
                    verticalAlignment = Alignment.CenterVertically
                ) {
                    TaskCalendarControlButton("<", onClick = {
                        if (month == 1) {
                            month = 12
                            year -= 1
                        } else {
                            month -= 1
                        }
                        day = day.coerceAtMost(taskDaysInMonth(year, month))
                    })
                    Text(
                        text = "${month.taskTwoDigits()} / $year",
                        modifier = Modifier.weight(1f),
                        color = theme.primaryText,
                        style = MaterialTheme.typography.titleLarge,
                        textAlign = TextAlign.Center
                    )
                    TaskCalendarControlButton(">", onClick = {
                        if (month == 12) {
                            month = 1
                            year += 1
                        } else {
                            month += 1
                        }
                        day = day.coerceAtMost(taskDaysInMonth(year, month))
                    })
                }

                TaskMonthGrid(
                    selectedDay = day,
                    daysInMonth = taskDaysInMonth(year, month),
                    onDaySelected = { day = it }
                )

                Text(strings.commonTime, color = theme.secondaryText, style = MaterialTheme.typography.labelLarge)
                Row(horizontalArrangement = Arrangement.spacedBy(10.dp), modifier = Modifier.fillMaxWidth()) {
                    TaskStepperValue(
                        label = strings.commonHour,
                        value = hour.taskTwoDigits(),
                        onDecrease = { hour = (hour + 23) % 24 },
                        onIncrease = { hour = (hour + 1) % 24 },
                        modifier = Modifier.weight(1f)
                    )
                    TaskStepperValue(
                        label = strings.commonMinute,
                        value = minute.taskTwoDigits(),
                        onDecrease = { minute = (minute + 45) % 60 },
                        onIncrease = { minute = (minute + 15) % 60 },
                        modifier = Modifier.weight(1f)
                    )
                }
            }
        },
        confirmButton = {
            TextButton(onClick = { onConfirm(taskIsoDateTime(year, month, day, hour, minute)) }) {
                Text(strings.commonDone)
            }
        },
        dismissButton = {
            TextButton(onClick = onDismiss) {
                Text(strings.commonCancel)
            }
        },
        containerColor = theme.surface,
        titleContentColor = theme.primaryText,
        textContentColor = theme.primaryText
    )
}

@Composable
private fun TaskMonthGrid(
    selectedDay: Int,
    daysInMonth: Int,
    onDaySelected: (Int) -> Unit
) {
    val theme = LocalHavnThemeTokens.current
    Column(verticalArrangement = Arrangement.spacedBy(6.dp)) {
        (1..daysInMonth).chunked(7).forEach { week ->
            Row(horizontalArrangement = Arrangement.spacedBy(6.dp), modifier = Modifier.fillMaxWidth()) {
                week.forEach { currentDay ->
                    val selected = selectedDay == currentDay
                    Surface(
                        modifier = Modifier.weight(1f),
                        onClick = { onDaySelected(currentDay) },
                        shape = MaterialTheme.shapes.small,
                        color = if (selected) theme.primaryAccent else theme.surface,
                        contentColor = if (selected) theme.background else theme.primaryText,
                        border = BorderStroke(1.dp, if (selected) theme.primaryAccent else theme.border)
                    ) {
                        Box(
                            modifier = Modifier.height(42.dp),
                            contentAlignment = Alignment.Center
                        ) {
                            Text(currentDay.toString(), style = MaterialTheme.typography.labelLarge)
                        }
                    }
                }
                repeat(7 - week.size) {
                    Spacer(Modifier.weight(1f))
                }
            }
        }
    }
}

@Composable
private fun TaskStepperValue(
    label: String,
    value: String,
    onDecrease: () -> Unit,
    onIncrease: () -> Unit,
    modifier: Modifier = Modifier
) {
    val theme = LocalHavnThemeTokens.current
    Surface(
        modifier = modifier,
        shape = MaterialTheme.shapes.medium,
        color = theme.surface,
        border = BorderStroke(1.dp, theme.border)
    ) {
        Column(
            modifier = Modifier.padding(10.dp),
            horizontalAlignment = Alignment.CenterHorizontally,
            verticalArrangement = Arrangement.spacedBy(6.dp)
        ) {
            Text(label, color = theme.secondaryText, style = MaterialTheme.typography.labelLarge)
            Row(horizontalArrangement = Arrangement.spacedBy(6.dp), verticalAlignment = Alignment.CenterVertically) {
                TaskCalendarControlButton("-", onClick = onDecrease, modifier = Modifier.size(44.dp))
                Text(value, color = theme.primaryText, style = MaterialTheme.typography.titleLarge)
                TaskCalendarControlButton("+", onClick = onIncrease, modifier = Modifier.size(44.dp))
            }
        }
    }
}

@Composable
private fun TaskCalendarControlButton(
    text: String,
    onClick: () -> Unit,
    modifier: Modifier = Modifier.size(54.dp)
) {
    val theme = LocalHavnThemeTokens.current
    Surface(
        modifier = modifier,
        onClick = onClick,
        shape = MaterialTheme.shapes.medium,
        color = theme.background.copy(alpha = 0.46f),
        contentColor = theme.primaryText,
        border = BorderStroke(1.dp, theme.border)
    ) {
        Box(contentAlignment = Alignment.Center) {
            Text(text, color = theme.primaryText, style = MaterialTheme.typography.titleMedium)
        }
    }
}

@Composable
private fun TaskAgentAssignmentPicker(
    members: List<AgencyMember>,
    selectedAgentId: String?,
    strings: HavnStrings,
    onAgentSelected: (String?) -> Unit
) {
    val theme = LocalHavnThemeTokens.current
    var showDialog by remember { mutableStateOf(false) }
    val sortedMembers = remember(members) { members.sortedForAgentPicker() }
    val selectedMember = sortedMembers.firstOrNull { it.agentId == selectedAgentId }
    val assignedName = selectedMember?.fullName ?: strings.wholeTeam

    HavnCard(border = BorderStroke(1.dp, theme.border)) {
        Column(verticalArrangement = Arrangement.spacedBy(12.dp)) {
            Row(verticalAlignment = Alignment.CenterVertically, horizontalArrangement = Arrangement.spacedBy(HavnSpacing.sm)) {
                HavnIcon(HavnIconKey.Users, contentDescription = null, tint = theme.primaryAccent, modifier = Modifier.size(18.dp))
                Text(strings.assignToAgent, color = theme.primaryText, style = MaterialTheme.typography.titleMedium)
            }
            Text(
                assignedName,
                color = theme.secondaryText,
                style = MaterialTheme.typography.bodyMedium,
                maxLines = 2,
                overflow = TextOverflow.Ellipsis
            )
            HavnButton(
                text = strings.assignTeam,
                onClick = { showDialog = true },
                style = HavnButtonStyle.Secondary,
                modifier = if (havnIsWebShell) Modifier.widthIn(max = 260.dp) else Modifier.fillMaxWidth(),
                leadingIcon = HavnIconKey.Sliders
            )
        }
    }

    if (showDialog) {
        TaskAgentAssignmentDialog(
            members = sortedMembers,
            selectedAgentId = selectedAgentId,
            strings = strings,
            onDismiss = { showDialog = false },
            onSave = { agentId ->
                showDialog = false
                onAgentSelected(agentId)
            }
        )
    }
}

@Composable
private fun TaskAgentAssignmentDialog(
    members: List<AgencyMember>,
    selectedAgentId: String?,
    strings: HavnStrings,
    onDismiss: () -> Unit,
    onSave: (String?) -> Unit
) {
    val theme = LocalHavnThemeTokens.current
    var selectedId by remember(selectedAgentId, members) { mutableStateOf(selectedAgentId) }
    var query by remember { mutableStateOf("") }
    val filteredMembers = remember(members, query) {
        val normalizedQuery = query.trim().lowercase()
        if (normalizedQuery.isBlank()) {
            members
        } else {
            members.filter { member ->
                member.fullName.contains(normalizedQuery, ignoreCase = true) ||
                    member.email.contains(normalizedQuery, ignoreCase = true) ||
                    member.role.displayName.contains(normalizedQuery, ignoreCase = true)
            }
        }
    }

    AlertDialog(
        onDismissRequest = onDismiss,
        containerColor = theme.card,
        title = { Text(strings.assignToAgent, color = theme.primaryText) },
        text = {
            Column(verticalArrangement = Arrangement.spacedBy(HavnSpacing.md)) {
                Text(
                    strings.taskVisibilityBody,
                    color = theme.secondaryText,
                    style = MaterialTheme.typography.bodyMedium
                )
                HavnSearchField(
                    value = query,
                    onValueChange = { query = it },
                    placeholder = strings.agents
                )
                TaskAssigneeRow(
                    title = strings.wholeTeam,
                    subtitle = "${members.size} ${strings.activeMembers}",
                    selected = selectedId == null,
                    onClick = { selectedId = null }
                )
                LazyColumn(
                    modifier = Modifier.heightIn(max = 340.dp),
                    verticalArrangement = Arrangement.spacedBy(HavnSpacing.sm)
                ) {
                    items(filteredMembers, key = { it.agentId ?: it.email }) { member ->
                        val memberAgentId = member.agentId ?: return@items
                        TaskAssigneeRow(
                            title = member.fullName,
                            subtitle = "${member.role.displayName} · ${member.email}",
                            selected = selectedId == memberAgentId,
                            onClick = { selectedId = memberAgentId }
                        )
                    }
                }
            }
        },
        confirmButton = {
            TextButton(onClick = { onSave(selectedId) }) {
                Text(strings.commonSave, color = theme.primaryAccent)
            }
        },
        dismissButton = {
            TextButton(onClick = onDismiss) {
                Text(strings.commonCancel, color = theme.secondaryText)
            }
        }
    )
}

@Composable
private fun TaskAssigneeRow(
    title: String,
    subtitle: String,
    selected: Boolean,
    onClick: () -> Unit
) {
    val theme = LocalHavnThemeTokens.current
    Surface(
        modifier = Modifier
            .fillMaxWidth()
            .clip(MaterialTheme.shapes.medium)
            .clickable(onClick = onClick),
        color = if (selected) theme.primaryAccent.copy(alpha = 0.14f) else theme.surface,
        border = BorderStroke(1.dp, if (selected) theme.primaryAccent else theme.border),
        shape = MaterialTheme.shapes.medium
    ) {
        Row(
            modifier = Modifier.padding(HavnSpacing.md),
            verticalAlignment = Alignment.CenterVertically,
            horizontalArrangement = Arrangement.spacedBy(HavnSpacing.md)
        ) {
            Surface(
                modifier = Modifier.size(34.dp),
                shape = CircleShape,
                color = if (selected) theme.primaryAccent else theme.surfaceElevated,
                border = BorderStroke(1.dp, if (selected) theme.primaryAccent else theme.border)
            ) {
                Box(contentAlignment = Alignment.Center) {
                    HavnIcon(
                        icon = if (selected) HavnIconKey.Check else HavnIconKey.Users,
                        contentDescription = null,
                        tint = if (selected) theme.background else theme.secondaryText,
                        modifier = Modifier.size(16.dp)
                    )
                }
            }
            Column(modifier = Modifier.weight(1f), verticalArrangement = Arrangement.spacedBy(2.dp)) {
                Text(title, color = theme.primaryText, style = MaterialTheme.typography.bodyLarge)
                Text(subtitle, color = theme.secondaryText, style = MaterialTheme.typography.labelMedium)
            }
        }
    }
}

private fun List<AgencyMember>.sortedForAgentPicker(): List<AgencyMember> = filter { it.agentId != null }.sortedWith(
    compareBy<AgencyMember> { it.status.name }
        .thenBy { it.fullName.lowercase() }
        .thenBy { it.email.lowercase() }
)

@Composable
private fun TaskPriorityRibbon(
    priority: HavnTaskPriority,
    selected: Boolean = true,
    onClick: (() -> Unit)? = null,
    modifier: Modifier = Modifier
) {
    val strings = LocalHavnStrings.current
    val accent = priority.priorityAccent()
    val background = if (selected) accent else accent.copy(alpha = 0.18f)
    val contentColor = if (selected) background.taskReadableTextColor() else accent
    Surface(
        color = background,
        contentColor = contentColor,
        shape = MaterialTheme.shapes.small,
        border = BorderStroke(1.dp, if (selected) contentColor.copy(alpha = 0.55f) else accent.copy(alpha = 0.46f)),
        modifier = modifier
            .clip(MaterialTheme.shapes.small)
            .then(if (onClick == null) Modifier else Modifier.clickable(onClick = onClick))
    ) {
        Text(
            priority.localizedLabel(strings),
            color = contentColor,
            style = MaterialTheme.typography.labelLarge,
            modifier = Modifier.padding(horizontal = 10.dp, vertical = 6.dp),
            maxLines = 1,
            overflow = TextOverflow.Ellipsis
        )
    }
}

@Composable
private fun TaskStatusSegmentedControl(
    selectedColumn: TaskBoardColumn,
    onColumnSelected: (TaskBoardColumn) -> Unit,
    modifier: Modifier = Modifier,
    enabled: Boolean = true
) {
    val strings = LocalHavnStrings.current
    val theme = LocalHavnThemeTokens.current
    val segments = TaskBoardColumn.entries
    Surface(
        modifier = modifier.fillMaxWidth(),
        shape = RoundedCornerShape(16.dp),
        color = theme.surface,
        border = BorderStroke(1.dp, theme.border)
    ) {
        Row(
            modifier = Modifier
                .fillMaxWidth()
                .padding(3.dp),
            horizontalArrangement = Arrangement.spacedBy(4.dp),
            verticalAlignment = Alignment.CenterVertically
        ) {
            segments.forEach { column ->
                val selected = selectedColumn == column
                HavnListFilterChip(
                    label = column.localizedLabel(strings),
                    selected = selected,
                    onClick = { onColumnSelected(column) },
                    modifier = Modifier.weight(1f),
                    enabled = enabled
                )
            }
        }
    }
}

@Composable
private fun TaskFilters(
    selected: TaskFilter,
    tasks: List<HavnTask>,
    suggestionCount: Int,
    wide: Boolean,
    onSelected: (TaskFilter) -> Unit
) {
    val strings = LocalHavnStrings.current
    val filters = TaskFilter.entries
    val chipContent = @Composable { filter: TaskFilter ->
        FilterChip(
            label = filter.label(strings),
            count = filter.countFor(tasks, suggestionCount),
            selected = selected == filter,
            onClick = { onSelected(filter) }
        )
    }
    if (wide) {
        Row(horizontalArrangement = Arrangement.spacedBy(8.dp), modifier = Modifier.fillMaxWidth()) {
            filters.forEach { filter -> chipContent(filter) }
        }
    } else {
        Column(verticalArrangement = Arrangement.spacedBy(8.dp), modifier = Modifier.fillMaxWidth()) {
            Row(horizontalArrangement = Arrangement.spacedBy(8.dp), modifier = Modifier.fillMaxWidth()) {
                filters.take(3).forEach { filter ->
                    Box(Modifier.weight(1f)) { chipContent(filter) }
                }
            }
            Row(horizontalArrangement = Arrangement.spacedBy(8.dp), modifier = Modifier.fillMaxWidth()) {
                filters.drop(3).forEach { filter ->
                    Box(Modifier.weight(1f)) { chipContent(filter) }
                }
            }
        }
    }
}

@Composable
private fun FilterChip(label: String, count: Int, selected: Boolean, onClick: () -> Unit) {
    val theme = LocalHavnThemeTokens.current
    Surface(
        color = if (selected) theme.primaryAccent.copy(alpha = 0.18f) else theme.card,
        shape = MaterialTheme.shapes.medium,
        border = BorderStroke(1.dp, if (selected) theme.primaryAccent else theme.border),
        modifier = Modifier.clickable(onClick = onClick)
    ) {
        Row(
            modifier = Modifier.fillMaxWidth().padding(horizontal = 10.dp, vertical = 9.dp),
            horizontalArrangement = Arrangement.Center,
            verticalAlignment = Alignment.CenterVertically
        ) {
            Text(
                "$label $count",
                color = if (selected) theme.primaryAccent else theme.secondaryText,
                style = MaterialTheme.typography.labelLarge,
                maxLines = 1,
                overflow = TextOverflow.Ellipsis
            )
        }
    }
}

@Composable
private fun KanbanBoard(
    tasks: List<HavnTask>,
    selectedTaskId: String?,
    context: TaskContextIndex,
    onSelect: (String) -> Unit,
    onMoveStatus: (String, HavnTaskStatus) -> Unit,
    wide: Boolean,
    modifier: Modifier
) {
    val columns = TaskKanbanColumn.entries
    if (wide) {
        Row(
            modifier = modifier.fillMaxWidth(),
            horizontalArrangement = Arrangement.spacedBy(12.dp),
            verticalAlignment = Alignment.Top
        ) {
            columns.forEach { column ->
                KanbanTaskColumn(
                    column = column,
                    tasks = tasks.forColumn(column),
                    selectedTaskId = selectedTaskId,
                    context = context,
                    onSelect = onSelect,
                    onMoveStatus = onMoveStatus,
                    modifier = Modifier.weight(1f)
                )
            }
        }
    } else {
        Column(
            modifier = modifier.fillMaxWidth(),
            verticalArrangement = Arrangement.spacedBy(12.dp)
        ) {
            columns.forEach { column ->
                KanbanTaskColumn(
                    column = column,
                    tasks = tasks.forColumn(column),
                    selectedTaskId = selectedTaskId,
                    context = context,
                    onSelect = onSelect,
                    onMoveStatus = onMoveStatus,
                    modifier = Modifier.fillMaxWidth()
                )
            }
        }
    }
}

@Composable
private fun KanbanTaskColumn(
    column: TaskKanbanColumn,
    tasks: List<HavnTask>,
    selectedTaskId: String?,
    context: TaskContextIndex,
    onSelect: (String) -> Unit,
    onMoveStatus: (String, HavnTaskStatus) -> Unit,
    modifier: Modifier
) {
    val theme = LocalHavnThemeTokens.current
    val strings = LocalHavnStrings.current
    HavnCard(modifier = modifier.heightIn(min = 220.dp), border = BorderStroke(1.dp, theme.border)) {
        Column(verticalArrangement = Arrangement.spacedBy(10.dp)) {
            Row(horizontalArrangement = Arrangement.spacedBy(8.dp), verticalAlignment = Alignment.CenterVertically) {
                Surface(Modifier.size(9.dp), color = column.accent(), shape = CircleShape) {}
                Text(column.title(strings), color = theme.primaryText, style = MaterialTheme.typography.titleMedium, modifier = Modifier.weight(1f))
                Badge(tasks.size.toString(), column.accent())
            }
            Text(column.subtitle(strings), color = theme.secondaryText, style = MaterialTheme.typography.bodySmall)
            if (tasks.isEmpty()) {
                Text(column.emptyText(strings), color = theme.mutedText, style = MaterialTheme.typography.bodyMedium)
            }
            tasks.forEach { task ->
                TaskCard(
                    task = task,
                    selected = task.id == selectedTaskId,
                    context = context,
                    onClick = { onSelect(task.id) },
                    onMoveStatus = { status -> onMoveStatus(task.id, status) }
                )
            }
        }
    }
}

@Composable
private fun TaskListColumn(
    tasks: List<HavnTask>,
    selectedTaskId: String?,
    context: TaskContextIndex,
    emptyText: String,
    onSelect: (String) -> Unit,
    onToggleDone: (HavnTask) -> Unit,
    modifier: Modifier
) {
    val strings = LocalHavnStrings.current
    HavnCard(modifier = modifier) {
        Column(verticalArrangement = Arrangement.spacedBy(10.dp)) {
            Text(strings.taskQueue, color = LocalHavnThemeTokens.current.primaryText, style = MaterialTheme.typography.titleMedium)
            if (tasks.isEmpty()) {
                Text(emptyText, color = LocalHavnThemeTokens.current.secondaryText, style = MaterialTheme.typography.bodyLarge)
            }
            tasks.forEach { task ->
                TaskCard(
                    task = task,
                    selected = task.id == selectedTaskId,
                    context = context,
                    onClick = { onSelect(task.id) },
                    onMoveStatus = { onToggleDone(task) }
                )
            }
        }
    }
}

@Composable
private fun TaskCard(
    task: HavnTask,
    selected: Boolean,
    context: TaskContextIndex,
    onClick: () -> Unit,
    onMoveStatus: (HavnTaskStatus) -> Unit
) {
    val theme = LocalHavnThemeTokens.current
    val strings = LocalHavnStrings.current
    Surface(
        color = if (selected) theme.primaryAccent.copy(alpha = 0.12f) else theme.surface,
        shape = MaterialTheme.shapes.medium,
        border = BorderStroke(1.dp, if (selected) theme.primaryAccent else theme.border),
        modifier = Modifier.fillMaxWidth().clickable(onClick = onClick)
    ) {
        Column(modifier = Modifier.padding(12.dp), verticalArrangement = Arrangement.spacedBy(9.dp)) {
            Row(horizontalArrangement = Arrangement.spacedBy(10.dp), verticalAlignment = Alignment.Top) {
                Checkbox(
                    checked = task.status == HavnTaskStatus.Done,
                    onCheckedChange = {
                        onMoveStatus(if (task.status == HavnTaskStatus.Done) HavnTaskStatus.Open else HavnTaskStatus.Done)
                    }
                )
                Column(modifier = Modifier.weight(1f), verticalArrangement = Arrangement.spacedBy(7.dp)) {
                    Row(horizontalArrangement = Arrangement.spacedBy(8.dp), verticalAlignment = Alignment.CenterVertically) {
                        Text(task.title, color = theme.primaryText, style = MaterialTheme.typography.titleSmall, maxLines = 2, overflow = TextOverflow.Ellipsis, modifier = Modifier.weight(1f))
                        TaskPriorityBadge(task.priority)
                        if (task.aiGenerated) AiBadge()
                    }
                    Text(task.description ?: task.type.label, color = theme.secondaryText, style = MaterialTheme.typography.bodyMedium, maxLines = 2, overflow = TextOverflow.Ellipsis)
                }
            }
            TaskQuickActionRow(task, context)
            Row(horizontalArrangement = Arrangement.spacedBy(8.dp), modifier = Modifier.fillMaxWidth()) {
                if (task.status == HavnTaskStatus.Done) {
                    HavnButton(
                        strings.reopen,
                        onClick = { onMoveStatus(HavnTaskStatus.Open) },
                        style = HavnButtonStyle.Secondary,
                        modifier = Modifier.weight(1f)
                    )
                } else {
                    task.previousKanbanStatus()?.let { previous ->
                        HavnButton(
                            previous.kanbanButtonLabel(strings),
                            onClick = { onMoveStatus(previous) },
                            style = HavnButtonStyle.Secondary,
                            modifier = Modifier.weight(1f)
                        )
                    }
                    task.nextKanbanStatus()?.let { next ->
                        HavnButton(
                            next.kanbanButtonLabel(strings),
                            onClick = { onMoveStatus(next) },
                            leadingIcon = if (next == HavnTaskStatus.Done) HavnIconKey.Check else null,
                            modifier = Modifier.weight(1f)
                        )
                    }
                }
            }
        }
    }
}

@Composable
private fun TaskQuickActionRow(task: HavnTask, context: TaskContextIndex) {
    val theme = LocalHavnThemeTokens.current
    val strings = LocalHavnStrings.current
    Row(horizontalArrangement = Arrangement.spacedBy(9.dp), verticalAlignment = Alignment.CenterVertically) {
        HavnIcon(HavnIconKey.Calendar, contentDescription = null, tint = theme.primaryAccent, modifier = Modifier.size(15.dp))
        Text(task.dueAt?.readableDateTime() ?: strings.noDueDate, color = theme.secondaryText, style = MaterialTheme.typography.labelMedium)
        context.propertyLabel(task)?.let { Text(it, color = theme.primaryAccent, style = MaterialTheme.typography.labelMedium, maxLines = 1, overflow = TextOverflow.Ellipsis) }
        context.contactLabel(task)?.let { Text(it, color = theme.secondaryText, style = MaterialTheme.typography.labelMedium, maxLines = 1, overflow = TextOverflow.Ellipsis) }
        context.leadLabel(task)?.let { Text(it, color = theme.secondaryText, style = MaterialTheme.typography.labelMedium, maxLines = 1, overflow = TextOverflow.Ellipsis) }
        context.memberLabel(task.assignedToUserId)?.let { Text(it, color = theme.mutedText, style = MaterialTheme.typography.labelMedium, maxLines = 1, overflow = TextOverflow.Ellipsis) }
    }
}

@Composable
private fun AiSuggestionsPanel(
    suggestions: List<AiSuggestedTask>,
    context: TaskContextIndex,
    onAccept: (HavnTaskDraft) -> Unit,
    onDismiss: (String) -> Unit
) {
    val strings = LocalHavnStrings.current
    HavnCard {
        Column(verticalArrangement = Arrangement.spacedBy(10.dp)) {
            Text(strings.aiSuggestedTasks, color = LocalHavnThemeTokens.current.primaryText, style = MaterialTheme.typography.titleMedium)
            if (suggestions.isEmpty()) {
                Text(strings.noAiSuggestedTasks, color = LocalHavnThemeTokens.current.secondaryText, style = MaterialTheme.typography.bodyMedium)
            }
            suggestions.take(5).forEach { suggestion ->
                AiSuggestedTaskCard(suggestion, context, onAccept, onDismiss)
            }
        }
    }
}

@Composable
private fun AiSuggestedTaskCard(
    suggestion: AiSuggestedTask,
    context: TaskContextIndex,
    onAccept: (HavnTaskDraft) -> Unit,
    onDismiss: (String) -> Unit
) {
    val theme = LocalHavnThemeTokens.current
    val strings = LocalHavnStrings.current
    Surface(color = theme.card, shape = MaterialTheme.shapes.medium, border = BorderStroke(1.dp, theme.primaryAccent.copy(alpha = 0.45f))) {
        Column(modifier = Modifier.padding(12.dp), verticalArrangement = Arrangement.spacedBy(8.dp)) {
            Row(horizontalArrangement = Arrangement.spacedBy(8.dp), verticalAlignment = Alignment.CenterVertically) {
                HavnIcon(HavnIconKey.Star, contentDescription = null, tint = theme.primaryAccent, modifier = Modifier.size(18.dp))
                Text(suggestion.draft.title, color = theme.primaryText, style = MaterialTheme.typography.titleSmall, modifier = Modifier.weight(1f))
                TaskPriorityBadge(suggestion.draft.priority)
            }
            Text(suggestion.reason, color = theme.secondaryText, style = MaterialTheme.typography.bodyMedium)
            TaskContextCard(
                property = context.properties[suggestion.draft.propertyId],
                contact = context.contacts[suggestion.draft.contactId],
                openHouse = context.openHouses[suggestion.draft.openHouseId],
                lead = context.leads[suggestion.draft.leadId]
            )
            Row(horizontalArrangement = Arrangement.spacedBy(8.dp)) {
                HavnButton(strings.accept, onClick = { onAccept(suggestion.draft) }, leadingIcon = HavnIconKey.Check, modifier = Modifier.weight(1f))
                HavnButton(strings.commonDismiss, onClick = { onDismiss(suggestion.id) }, style = HavnButtonStyle.Secondary, modifier = Modifier.weight(1f))
            }
        }
    }
}

@Composable
private fun TaskDetailScreen(
    task: HavnTask?,
    context: TaskContextIndex,
    onMoveStatus: (HavnTaskStatus) -> Unit
) {
    val theme = LocalHavnThemeTokens.current
    val strings = LocalHavnStrings.current
    HavnCard {
        Column(verticalArrangement = Arrangement.spacedBy(12.dp)) {
            Text(strings.taskDetail, color = theme.primaryText, style = MaterialTheme.typography.titleMedium)
            if (task == null) {
                Text(strings.taskDetailEmpty, color = theme.secondaryText, style = MaterialTheme.typography.bodyLarge)
                return@HavnCard
            }
            Row(horizontalArrangement = Arrangement.spacedBy(8.dp), verticalAlignment = Alignment.CenterVertically) {
                Text(task.title, color = theme.primaryText, style = MaterialTheme.typography.headlineSmall, modifier = Modifier.weight(1f))
                TaskStatusBadge(task.status)
            }
            Text(task.description ?: task.type.label, color = theme.secondaryText, style = MaterialTheme.typography.bodyLarge)
            Row(horizontalArrangement = Arrangement.spacedBy(8.dp)) {
                TaskPriorityBadge(task.priority)
                SmallMeta(task.dueAt?.readableDateTime() ?: strings.noDueDate)
                if (task.aiGenerated) AiBadge()
            }
            TaskContextCard(
                property = context.properties[task.propertyId],
                contact = context.contacts[task.contactId],
                openHouse = context.openHouses[task.openHouseId],
                lead = context.leads[task.leadId]
            )
            if (!task.notes.isNullOrBlank()) {
                Text(strings.notes, color = theme.primaryAccent, style = MaterialTheme.typography.labelLarge)
                Text(task.notes, color = theme.primaryText, style = MaterialTheme.typography.bodyMedium)
            }
            TaskTimeline(task)
            Row(horizontalArrangement = Arrangement.spacedBy(10.dp), modifier = Modifier.fillMaxWidth()) {
                task.previousKanbanStatus()?.let { previous ->
                    HavnButton(
                        previous.kanbanButtonLabel(strings),
                        onClick = { onMoveStatus(previous) },
                        style = HavnButtonStyle.Secondary,
                        modifier = Modifier.weight(1f)
                    )
                }
                task.nextKanbanStatus()?.let { next ->
                    HavnButton(
                        next.kanbanButtonLabel(strings),
                        onClick = { onMoveStatus(next) },
                        leadingIcon = if (next == HavnTaskStatus.Done) HavnIconKey.Check else null,
                        modifier = Modifier.weight(1f)
                    )
                }
                HavnButton(strings.editTask, onClick = {}, style = HavnButtonStyle.Secondary, leadingIcon = HavnIconKey.Settings, modifier = Modifier.weight(1f))
            }
        }
    }
}

@Composable
private fun TaskContextCard(
    property: Property?,
    contact: Client?,
    openHouse: OpenHouse?,
    lead: Lead?,
    onOpenProperty: (String) -> Unit = {},
    onOpenContact: (String) -> Unit = {},
    onOpenOpening: (String) -> Unit = {},
    onOpenLead: (String) -> Unit = {}
) {
    val theme = LocalHavnThemeTokens.current
    val strings = LocalHavnStrings.current
    Surface(color = theme.surface, shape = MaterialTheme.shapes.medium, border = BorderStroke(1.dp, theme.border), modifier = Modifier.fillMaxWidth()) {
        Column(modifier = Modifier.padding(12.dp), verticalArrangement = Arrangement.spacedBy(8.dp)) {
            Text(strings.connectedContext, color = theme.primaryAccent, style = MaterialTheme.typography.labelLarge)
            if (property == null && contact == null && openHouse == null && lead == null) {
                Text(strings.noTaskContext, color = theme.secondaryText, style = MaterialTheme.typography.bodyMedium)
            }
            property?.let {
                ContextLine(HavnIconKey.Home, it.title, it.displayCity, onClick = { onOpenProperty(it.id) })
            }
            contact?.let {
                ContextLine(HavnIconKey.User, it.fullName, it.contactLine, onClick = { onOpenContact(it.id) })
            }
            openHouse?.let {
                ContextLine(HavnIconKey.CalendarClock, it.displayTitle, it.startsAt.readableDateTime(), onClick = { onOpenOpening(it.id) })
            }
            lead?.let {
                ContextLine(HavnIconKey.Leads, it.fullName, it.sourceLine, onClick = { onOpenLead(it.id) })
            }
        }
    }
}

@Composable
private fun TaskTimeline(task: HavnTask) {
    val strings = LocalHavnStrings.current
    Column(verticalArrangement = Arrangement.spacedBy(8.dp)) {
        Text(strings.activityTimeline, color = LocalHavnThemeTokens.current.primaryAccent, style = MaterialTheme.typography.labelLarge)
        TimelineLine(strings.created, task.createdAt?.readableDateTime() ?: strings.recently)
        if (task.status == HavnTaskStatus.Done) {
            TimelineLine(strings.completed, task.completedAt?.readableDateTime() ?: strings.completed)
        } else {
            TimelineLine(strings.nextAction, strings.agentReviewOrCompletion)
        }
    }
}

@Composable
private fun TimelineLine(label: String, value: String) {
    val theme = LocalHavnThemeTokens.current
    Row(horizontalArrangement = Arrangement.spacedBy(10.dp), verticalAlignment = Alignment.CenterVertically) {
        Surface(Modifier.size(8.dp), color = theme.primaryAccent, shape = CircleShape) {}
        Text(label, color = theme.primaryText, style = MaterialTheme.typography.labelLarge)
        Text(value, color = theme.secondaryText, style = MaterialTheme.typography.bodyMedium)
    }
}

@Composable
private fun ContextLine(icon: HavnIconKey, title: String, subtitle: String, onClick: (() -> Unit)? = null) {
    val theme = LocalHavnThemeTokens.current
    val rowModifier = onClick?.let { Modifier.fillMaxWidth().clickable(onClick = it) } ?: Modifier.fillMaxWidth()
    Row(modifier = rowModifier, horizontalArrangement = Arrangement.spacedBy(9.dp), verticalAlignment = Alignment.CenterVertically) {
        HavnIcon(icon, contentDescription = null, tint = theme.primaryAccent, modifier = Modifier.size(17.dp))
        Column(modifier = Modifier.weight(1f)) {
            Text(title, color = theme.primaryText, style = MaterialTheme.typography.labelLarge, maxLines = 1, overflow = TextOverflow.Ellipsis)
            Text(subtitle, color = theme.secondaryText, style = MaterialTheme.typography.labelMedium, maxLines = 1, overflow = TextOverflow.Ellipsis)
        }
        if (onClick != null) {
            HavnIcon(HavnIconKey.ArrowRight, contentDescription = null, tint = theme.primaryAccent, modifier = Modifier.size(15.dp))
        }
    }
}

@Composable
private fun TaskPriorityBadge(priority: HavnTaskPriority) {
    TaskPriorityRibbon(priority = priority)
}

@Composable
private fun TaskStatusBadge(status: HavnTaskStatus) {
    val theme = LocalHavnThemeTokens.current
    val strings = LocalHavnStrings.current
    val accent = when (status) {
        HavnTaskStatus.Done -> theme.success
        HavnTaskStatus.Overdue -> theme.danger
        HavnTaskStatus.InProgress -> theme.warning
        HavnTaskStatus.Cancelled -> theme.mutedText
        HavnTaskStatus.Open -> theme.primaryAccent
    }
    Badge(status.localizedLabel(strings), accent)
}

@Composable
private fun AiBadge() {
    Badge("AI", LocalHavnThemeTokens.current.secondaryAccent)
}

@Composable
private fun SmallMeta(text: String) {
    Badge(text, LocalHavnThemeTokens.current.secondaryText)
}

@Composable
private fun Badge(text: String, accent: Color) {
    Surface(color = accent.copy(alpha = 0.14f), shape = MaterialTheme.shapes.small, border = BorderStroke(1.dp, accent.copy(alpha = 0.45f))) {
        Text(text, color = accent, style = MaterialTheme.typography.labelSmall, modifier = Modifier.padding(horizontal = 8.dp, vertical = 5.dp), maxLines = 1)
    }
}

private data class TaskContextIndex(
    val properties: Map<String, Property>,
    val openHouses: Map<String, OpenHouse>,
    val leads: Map<String, Lead>,
    val followUps: Map<String, FollowUp>,
    val contacts: Map<String, Client>,
    val members: Map<String?, AgencyMember>
) {
    fun propertyLabel(task: HavnTask): String? =
        properties[task.propertyId]?.title
            ?: leads[task.leadId]?.sourceProperty?.title
            ?: openHouses[task.openHouseId]?.propertyTitle

    fun leadLabel(task: HavnTask): String? = leads[task.leadId]?.fullName

    fun contactLabel(task: HavnTask): String? = contacts[task.contactId]?.fullName

    fun memberLabel(agentId: String?): String? = members[agentId]?.fullName

    fun allAttachmentRecipients(): List<HavnAttachmentRecipient> =
        contacts.values.map { it.toAttachmentRecipient() } +
            members.values.mapNotNull { it.toAttachmentRecipient() }

    fun linkedAttachmentRecipients(task: HavnTask): List<HavnAttachmentRecipient> = buildList {
        task.contactId?.let { contacts[it]?.toAttachmentRecipient()?.let(::add) }
        task.leadId?.let { leads[it]?.toAttachmentRecipient()?.let(::add) }
        task.assignedToUserId?.let { members[it]?.toAttachmentRecipient()?.let(::add) }
        task.createdByUserId.let { members[it]?.toAttachmentRecipient()?.let(::add) }
        task.propertyId?.let { propertyId ->
            contacts.values
                .filter { contact -> contact.openings.any { it.propertyId == propertyId } }
                .map { it.toAttachmentRecipient() }
                .forEach(::add)
        }
    }.dedupeAttachmentRecipients()
}

private fun Client.toAttachmentRecipient(): HavnAttachmentRecipient = HavnAttachmentRecipient(
    id = "contact:$id",
    displayName = fullName,
    email = email,
    phone = phone,
    source = HavnAttachmentRecipientSource.Contact
)

private fun Lead.toAttachmentRecipient(): HavnAttachmentRecipient = HavnAttachmentRecipient(
    id = contactId?.let { "contact:$it" } ?: "lead:$id",
    displayName = fullName,
    email = email,
    phone = phone,
    source = HavnAttachmentRecipientSource.Contact
)

private fun AgencyMember.toAttachmentRecipient(): HavnAttachmentRecipient? {
    val memberId = agentId ?: invitationId ?: email.takeIf { it.isNotBlank() } ?: return null
    return HavnAttachmentRecipient(
        id = "agent:$memberId",
        displayName = fullName,
        email = email.takeIf { it.isNotBlank() },
        phone = null,
        source = HavnAttachmentRecipientSource.Agent
    )
}

private fun List<HavnAttachmentRecipient>.dedupeAttachmentRecipients(): List<HavnAttachmentRecipient> =
    distinctBy { recipient -> recipient.id }

private enum class TaskKanbanColumn {
    ToDo,
    InProgress,
    Done
}

@Composable
private fun TaskKanbanColumn.accent(): Color {
    val theme = LocalHavnThemeTokens.current
    return when (this) {
        TaskKanbanColumn.ToDo -> theme.primaryAccent
        TaskKanbanColumn.InProgress -> theme.warning
        TaskKanbanColumn.Done -> theme.success
    }
}

private enum class TaskFilter {
    Today,
    Upcoming,
    Overdue,
    Completed,
    AssignedToMe,
    AiSuggested
}

private fun TaskFilter.countFor(tasks: List<HavnTask>, suggestionCount: Int): Int = when (this) {
    TaskFilter.AiSuggested -> suggestionCount
    else -> tasks.filterBy(this).size
}

private fun List<HavnTask>.filterBy(filter: TaskFilter): List<HavnTask> = when (filter) {
    TaskFilter.Today -> filter { it.isToday() && it.status != HavnTaskStatus.Done }
    TaskFilter.Upcoming -> filter { !it.isToday() && !it.isOverdue() && it.status != HavnTaskStatus.Done }
    TaskFilter.Overdue -> filter { it.isOverdue() && it.status != HavnTaskStatus.Done }
    TaskFilter.Completed -> filter { it.status == HavnTaskStatus.Done }
    TaskFilter.AssignedToMe -> filter { it.status != HavnTaskStatus.Done }
    TaskFilter.AiSuggested -> filter { it.aiGenerated }
}.sortedForDisplay()

private fun List<HavnTask>.forColumn(column: TaskKanbanColumn): List<HavnTask> =
    filter { it.kanbanColumn() == column }
        .sortedForDisplay()

private fun List<HavnTask>.sortedForDisplay(): List<HavnTask> =
    sortedWith(
        compareByDescending<HavnTask> { it.updatedAt ?: it.createdAt ?: it.dueAt.orEmpty() }
            .thenByDescending { it.createdAt ?: it.dueAt.orEmpty() }
            .thenByDescending { it.priority.sortWeight() }
            .thenBy { it.dueAt ?: "9999" }
            .thenBy { it.id }
    )

private fun HavnTask.kanbanColumn(): TaskKanbanColumn = when (status) {
    HavnTaskStatus.Open,
    HavnTaskStatus.Overdue -> TaskKanbanColumn.ToDo
    HavnTaskStatus.InProgress -> TaskKanbanColumn.InProgress
    HavnTaskStatus.Done -> TaskKanbanColumn.Done
    HavnTaskStatus.Cancelled -> TaskKanbanColumn.Done
}

private fun HavnTaskPriority.sortWeight(): Int = when (this) {
    HavnTaskPriority.Urgent -> 4
    HavnTaskPriority.High -> 3
    HavnTaskPriority.Medium -> 2
    HavnTaskPriority.Low -> 1
}

private fun HavnTaskPriority.localizedLabel(strings: HavnStrings): String = when (this) {
    HavnTaskPriority.Low -> strings.taskPriorityLow
    HavnTaskPriority.Medium -> strings.taskPriorityMedium
    HavnTaskPriority.High -> strings.taskPriorityHigh
    HavnTaskPriority.Urgent -> strings.taskPriorityUrgent
}

private fun TaskKanbanColumn.title(strings: HavnStrings): String = when (this) {
    TaskKanbanColumn.ToDo -> strings.taskColumnToDo
    TaskKanbanColumn.InProgress -> strings.taskColumnInProgress
    TaskKanbanColumn.Done -> strings.taskColumnDone
}

private fun TaskKanbanColumn.subtitle(strings: HavnStrings): String = when (this) {
    TaskKanbanColumn.ToDo -> strings.taskColumnToDoSubtitle
    TaskKanbanColumn.InProgress -> strings.taskColumnInProgressSubtitle
    TaskKanbanColumn.Done -> strings.taskColumnDoneSubtitle
}

private fun TaskKanbanColumn.emptyText(strings: HavnStrings): String = when (this) {
    TaskKanbanColumn.ToDo -> strings.taskKanbanEmptyToDo
    TaskKanbanColumn.InProgress -> strings.taskKanbanEmptyInProgress
    TaskKanbanColumn.Done -> strings.taskKanbanEmptyDone
}

private fun TaskFilter.label(strings: HavnStrings): String = when (this) {
    TaskFilter.Today -> strings.taskFilterToday
    TaskFilter.Upcoming -> strings.taskFilterUpcoming
    TaskFilter.Overdue -> strings.taskFilterOverdue
    TaskFilter.Completed -> strings.taskFilterCompleted
    TaskFilter.AssignedToMe -> strings.taskFilterAssignedToMe
    TaskFilter.AiSuggested -> strings.taskFilterAiSuggested
}

private fun TaskFilter.emptyText(strings: HavnStrings): String = when (this) {
    TaskFilter.Today -> strings.taskFilterEmptyToday
    TaskFilter.Upcoming -> strings.taskFilterEmptyUpcoming
    TaskFilter.Overdue -> strings.taskFilterEmptyOverdue
    TaskFilter.Completed -> strings.taskFilterEmptyCompleted
    TaskFilter.AssignedToMe -> strings.taskFilterEmptyAssignedToMe
    TaskFilter.AiSuggested -> strings.taskFilterEmptyAiSuggested
}

private fun HavnTaskStatus.localizedLabel(strings: HavnStrings): String = when (this) {
    HavnTaskStatus.Open -> strings.taskStatusOpen
    HavnTaskStatus.InProgress -> strings.taskStatusInProgress
    HavnTaskStatus.Done -> strings.taskStatusDone
    HavnTaskStatus.Overdue -> strings.taskStatusOverdue
    HavnTaskStatus.Cancelled -> strings.taskStatusCancelled
}

@Composable
private fun HavnTaskPriority.priorityAccent(): Color {
    val theme = LocalHavnThemeTokens.current
    return when (this) {
        HavnTaskPriority.Low -> theme.cold
        HavnTaskPriority.Medium -> theme.success
        HavnTaskPriority.High -> theme.warning
        HavnTaskPriority.Urgent -> theme.danger
    }
}

private fun Color.taskReadableTextColor(): Color {
    val luminance = (0.299f * red) + (0.587f * green) + (0.114f * blue)
    return if (luminance > 0.58f) Color.Black else Color.White
}

private fun HavnTask.previousKanbanStatus(): HavnTaskStatus? = when (status) {
    HavnTaskStatus.InProgress -> HavnTaskStatus.Open
    HavnTaskStatus.Done -> HavnTaskStatus.InProgress
    else -> null
}

private fun HavnTask.nextKanbanStatus(): HavnTaskStatus? = when (status) {
    HavnTaskStatus.Open,
    HavnTaskStatus.Overdue -> HavnTaskStatus.InProgress
    HavnTaskStatus.InProgress -> HavnTaskStatus.Done
    else -> null
}

private fun HavnTaskStatus.kanbanButtonLabel(strings: HavnStrings): String = when (this) {
    HavnTaskStatus.Open -> strings.taskColumnToDo
    HavnTaskStatus.InProgress -> strings.taskActionStart
    HavnTaskStatus.Done -> strings.taskColumnDone
    HavnTaskStatus.Overdue -> strings.taskActionOverdue
    HavnTaskStatus.Cancelled -> strings.taskActionCancel
}

private fun List<HavnTask>.forBoardColumn(column: TaskBoardColumn): List<HavnTask> =
    filter { task ->
        when (column) {
            TaskBoardColumn.ToDo -> task.status == HavnTaskStatus.Open || (task.status == HavnTaskStatus.Overdue && !task.isOverdue())
            TaskBoardColumn.InProgress -> task.status == HavnTaskStatus.InProgress
            TaskBoardColumn.Done -> task.status == HavnTaskStatus.Done
        }
    }.sortedWith(
        compareByDescending<HavnTask> { it.updatedAt ?: it.createdAt ?: "" }
            .thenByDescending { it.priority.sortWeight() }
            .thenBy { it.dueAt ?: "9999" }
    )

private fun List<HavnTask>.searchTasks(query: String, context: TaskContextIndex): List<HavnTask> {
    val normalized = query.trim().lowercase()
    if (normalized.isBlank()) return this
    return filter { task ->
        listOfNotNull(
            task.title,
            task.description,
            task.type.label,
            task.priority.label,
            context.propertyLabel(task),
            context.leadLabel(task),
            context.memberLabel(task.assignedToUserId)
        ).any { it.lowercase().contains(normalized) }
    }
}

@Composable
private fun TaskBoardColumn.accent(): Color {
    val theme = LocalHavnThemeTokens.current
    return when (this) {
        TaskBoardColumn.ToDo -> theme.primaryAccent
        TaskBoardColumn.InProgress -> theme.warning
        TaskBoardColumn.Done -> theme.success
    }
}

private fun TaskBoardColumn.localizedLabel(strings: HavnStrings): String = when (this) {
    TaskBoardColumn.ToDo -> strings.taskColumnToDo
    TaskBoardColumn.InProgress -> strings.taskColumnInProgress
    TaskBoardColumn.Done -> strings.taskColumnDone
}

private fun TaskBoardColumn.emptyTitle(strings: HavnStrings): String = when (this) {
    TaskBoardColumn.ToDo -> strings.taskEmptyToDo
    TaskBoardColumn.InProgress -> strings.taskEmptyInProgress
    TaskBoardColumn.Done -> strings.taskEmptyDone
}

private fun HavnTaskStatus.taskActionLabel(strings: HavnStrings): String = when (this) {
    HavnTaskStatus.InProgress -> strings.taskActionStart
    HavnTaskStatus.Done -> strings.taskColumnDone
    HavnTaskStatus.Open -> strings.taskColumnToDo
    HavnTaskStatus.Overdue -> strings.taskActionOverdue
    HavnTaskStatus.Cancelled -> strings.taskActionCancel
}

private fun TaskScreenMode.navigationDepth(): Int = when (this) {
    TaskScreenMode.Board -> 0
    TaskScreenMode.Editor -> 1
}

private fun buildAiSuggestions(
    leads: List<Lead>,
    openHouses: List<OpenHouse>,
    followUps: List<FollowUp>,
    agencyId: String?,
    dismissedIds: Set<String>,
    strings: HavnStrings
): List<AiSuggestedTask> {
    val suggestions = mutableListOf<AiSuggestedTask>()
    leads.filter { it.temperature == LeadTemperature.Hot }.take(3).forEach { lead ->
        suggestions += AiSuggestedTask(
            id = "hot-lead:${lead.id}",
            draft = HavnTaskDraft(
                title = "${strings.taskSuggestionHotLeadTitlePrefix} ${lead.fullName} ${strings.taskSuggestionHotLeadTitleSuffix}",
                description = "${strings.taskSuggestionHotLeadDescriptionPrefix} ${lead.sourceProperty.title}. ${strings.taskSuggestionHotLeadDescriptionSuffix}",
                type = HavnTaskType.FollowUpLead,
                priority = HavnTaskPriority.Urgent,
                dueAt = lead.checkedInAt,
                assignedToUserId = null,
                agencyId = agencyId,
                propertyId = lead.propertyId,
                openHouseId = lead.openHouseId,
                leadId = lead.id,
                aiGenerated = true
            ),
            reason = strings.taskSuggestionHotLeadReason
        )
    }
    openHouses.filter { it.status == OpenHouseStatus.Completed }.take(2).forEach { opening ->
        suggestions += AiSuggestedTask(
            id = "report:${opening.id}",
            draft = HavnTaskDraft(
                title = "${strings.taskSuggestionSellerReportTitlePrefix} ${opening.propertyTitle}${strings.taskSuggestionSellerReportTitleSuffix}",
                description = strings.taskSuggestionSellerReportDescription,
                type = HavnTaskType.PrepareSellerReport,
                priority = HavnTaskPriority.High,
                dueAt = opening.endsAt,
                agencyId = agencyId,
                propertyId = opening.propertyId,
                openHouseId = opening.id,
                aiGenerated = true
            ),
            reason = strings.taskSuggestionSellerReportReason
        )
    }
    followUps.filter { it.status != FollowUpStatus.Completed }.take(2).forEach { followUp ->
        suggestions += AiSuggestedTask(
            id = "review-follow-up:${followUp.id}",
            draft = HavnTaskDraft(
                title = "${strings.taskSuggestionReviewFollowUpTitlePrefix} ${followUp.channel.label.lowercase()} ${strings.taskSuggestionReviewFollowUpTitleSuffix}",
                description = followUp.subject,
                type = HavnTaskType.ReviewAiFollowUp,
                priority = HavnTaskPriority.Medium,
                dueAt = followUp.dueAt,
                agencyId = agencyId,
                followUpId = followUp.id,
                aiGenerated = true
            ),
            reason = strings.taskSuggestionReviewFollowUpReason
        )
    }
    openHouses.filter { it.status == OpenHouseStatus.Scheduled }.take(2).forEach { opening ->
        suggestions += AiSuggestedTask(
            id = "kiosk:${opening.id}",
            draft = HavnTaskDraft(
                title = strings.taskSuggestionKioskTitle,
                description = strings.taskSuggestionKioskDescription,
                type = HavnTaskType.SetupKioskMode,
                priority = HavnTaskPriority.Medium,
                dueAt = opening.startsAt,
                agencyId = agencyId,
                propertyId = opening.propertyId,
                openHouseId = opening.id,
                aiGenerated = true
            ),
            reason = strings.taskSuggestionKioskReason
        )
    }
    return suggestions
        .filterNot { it.id in dismissedIds || it.draft.suggestionKey() in dismissedIds }
        .distinctBy { it.id }
        .take(6)
}

private fun HavnTask.isToday(): Boolean = dueAt?.substringBefore("T") == todayIsoDate()

@OptIn(ExperimentalTime::class)
private fun HavnTask.isOverdue(): Boolean {
    if (status == HavnTaskStatus.Done || status == HavnTaskStatus.Cancelled) return false
    val due = dueAt ?: return false
    val dueMs = due.instantMillisOrNull()
    return if (dueMs != null) {
        dueMs < Clock.System.now().toEpochMilliseconds()
    } else {
        due < Clock.System.now().toString()
    }
}

@OptIn(ExperimentalTime::class)
private fun String.instantMillisOrNull(): Long? = runCatching {
    Instant.parse(this).toEpochMilliseconds()
}.getOrNull()

private data class TaskDateTimeSelection(
    val year: Int,
    val month: Int,
    val day: Int,
    val hour: Int,
    val minute: Int
) {
    companion object {
        fun fromIso(value: String): TaskDateTimeSelection {
            val fallback = todaySelection()
            val date = value.substringBefore("T")
            val time = value.substringAfter("T", "18:00").substringBefore("Z").substringBefore("+").substringBefore(".")
            val parts = date.split("-")
            val timeParts = time.split(":")
            return TaskDateTimeSelection(
                year = parts.getOrNull(0)?.toIntOrNull() ?: fallback.year,
                month = parts.getOrNull(1)?.toIntOrNull()?.coerceIn(1, 12) ?: fallback.month,
                day = parts.getOrNull(2)?.toIntOrNull()?.coerceIn(1, 31) ?: fallback.day,
                hour = timeParts.getOrNull(0)?.toIntOrNull()?.coerceIn(0, 23) ?: 18,
                minute = timeParts.getOrNull(1)?.toIntOrNull()?.coerceIn(0, 59) ?: 0
            )
        }

        @OptIn(ExperimentalTime::class)
        private fun todaySelection(): TaskDateTimeSelection {
            val parts = Clock.System.now().toString().substringBefore("T").split("-")
            return TaskDateTimeSelection(
                year = parts.getOrNull(0)?.toIntOrNull() ?: 2026,
                month = parts.getOrNull(1)?.toIntOrNull()?.coerceIn(1, 12) ?: 1,
                day = parts.getOrNull(2)?.toIntOrNull()?.coerceIn(1, 31) ?: 1,
                hour = 18,
                minute = 0
            )
        }
    }
}

private fun taskIsoDateTime(year: Int, month: Int, day: Int, hour: Int, minute: Int): String =
    "${year}-${month.taskTwoDigits()}-${day.taskTwoDigits()}T${hour.taskTwoDigits()}:${minute.taskTwoDigits()}:00Z"

private fun taskDaysInMonth(year: Int, month: Int): Int = when (month) {
    1, 3, 5, 7, 8, 10, 12 -> 31
    4, 6, 9, 11 -> 30
    2 -> if ((year % 4 == 0 && year % 100 != 0) || year % 400 == 0) 29 else 28
    else -> 30
}

private fun Int.taskTwoDigits(): String = toString().padStart(2, '0')

@OptIn(ExperimentalTime::class)
private fun todayIsoDate(): String = Clock.System.now().toString().substringBefore("T")

private fun String.readableDateTime(): String {
    val clean = cleanTaskDateTime()
    val date = clean.substringBefore(" ").readableTaskDate()
    val time = clean.substringAfter(" ", "").readableTaskTime()
    return listOfNotNull(date, time).joinToString(" · ").ifBlank { clean }
}

private fun String.cleanTaskDateTime(): String =
    replace("T", " ").substringBefore(".").substringBefore("+").substringBefore("Z")

private fun String.readableTaskDate(): String? {
    val parts = split("-")
    if (parts.size != 3) return null
    val month = parts[1].toIntOrNull()?.let { taskMonthNames.getOrNull(it - 1) } ?: return null
    val day = parts[2].toIntOrNull() ?: return null
    return "$month $day"
}

private fun String.readableTaskTime(): String? {
    if (":" !in this) return null
    val hour = substringBefore(":").toIntOrNull() ?: return null
    val minute = substringAfter(":").take(2).padStart(2, '0')
    val displayHour = when {
        hour == 0 -> 12
        hour > 12 -> hour - 12
        else -> hour
    }
    val suffix = if (hour >= 12) "PM" else "AM"
    return "$displayHour:$minute $suffix"
}

private val taskMonthNames = listOf("Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul", "Aug", "Sep", "Oct", "Nov", "Dec")

private fun HavnTaskDraft.suggestionKey(): String =
    listOf(type.databaseValue, propertyId, openHouseId, leadId, followUpId, title).joinToString(":")
